import { FC } from "react";
import { Box, CircularProgress } from "@mui/material";

// Deliberately avoids the Components barrel: that barrel has internal
// circular imports (see Components/index.tsx import order) that only
// resolve safely once something else has already warmed the module
// graph up. This fallback needs to be safe to import as early and as
// often as any layout component might need it.
const RouteFallback: FC = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    height="100%"
    width="100%"
  >
    <CircularProgress />
  </Box>
);

export default RouteFallback;
